export default {
  orgSetting: '机构设置',
  chatbot: '聊天机器人',
  crm: '客户管理',
  marketplace: '应用市场',

}